import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { LoggedInUser } from 'app/models/useridentity.model';
import { Subject, takeUntil } from 'rxjs';
import { RouterModule } from '@angular/router';
import { PaymentService } from 'app/main/payment/payment.service';
import { GlobalCompanyService } from 'app/shared/component/global-company/global-company.service';
 
@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    standalone: true,
    imports: [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        NgClass,
        MatDividerModule,
        RouterModule
    ],
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */
    planSubscription: string;
    @Input() showAvatar: boolean = true;
    user: User;
  companyId = 0;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
 
    /**
     * Constructor
     */
    constructor(  private paymentService: PaymentService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
            private globalCompanyServcie: GlobalCompanyService,
        private _userService: UserService
    ) {
 
       
    }
 
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
 
    /**
     * On init
     */
    ngOnInit(): void {
       
 
       
        // Subscribe to user changes
        let currentUserObj = JSON.parse(String(localStorage.getItem('currentUser')));
        if (currentUserObj) {
            this.user = currentUserObj;
        }
 
        this.globalCompanyServcie.globalCompany.subscribe(res => {
           
              if (res === 0) {            
           
              } else {            
                this.companyId = res;
                    this.checkUserSubscription();
              }
            });
        // this._userService.user$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((user: User) => {
        //         this.user = user;
 
        //         // Mark for check
        //         this._changeDetectorRef.markForCheck();
        //     });
    }
 async checkUserSubscription() {
   
      const user = JSON.parse(localStorage.getItem('userDetails') || '{}');
      const uid = user.userId;    
      const companyId = this.companyId;
     
      const data = await this.paymentService.GetUserSubscriptionDetailsWithPagesProfile(uid,companyId).toPromise();
   
      this.planSubscription = data.data.planName ;
     
   
  }
getPlanIcon(): string {
   
    const plan = this.planSubscription?.toLowerCase();
   
    switch(plan) {
        case 'free':  
            return 'heroicons_outline:user';
        case 'gold':
 
            return 'heroicons_outline:star';
        case 'silver':
 
            return 'heroicons_outline:building-office';
 
        case 'platinum':
            return 'heroicons_outline:crown';
        default:
            return 'heroicons_outline:identification';
    }
}
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
 
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
 
    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }
 
        // Update the user
        this._userService
            .update({
                ...this.user,
                status,
            })
            .subscribe();
    }
 
    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
}